import { useEffect } from "react";
import { AppOverlay } from "../../../../functions/classes/miscelleanous.classes.js";

/**
 * Sagt an ob POI Cards auffahren dürfen
 * @param props
 * @return {boolean}
 */
export function useShowPoiCards(props) {
  // infocard muss geschlossen sein!
  useEffect(() => {
    //dürfen nicht gezeigt werden, wenn search offen ist!
    if (props.currentAppOverlay.name === AppOverlay.names.search) {
      props.toggleIsFullMap(true);
    }
  }, [props.currentAppOverlay]);

  return (
    props.infoCardStatus === "close" && !(props.isFullMap || !props.mapLoaded)
  );
}
